import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { BillingDoOrdenControlDialogComponent } from '../../dialogs/billing-do-orden-control-dialog/billing-do-orden-control-dialog.component';
import { BillingOrderControlService } from '../../../services/billing/billing-order-control.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-billing-order-search',
  templateUrl: './billing-order-search.component.html',
  styleUrls: ['./billing-order-search.component.css']
})
export class BillingOrderSearchComponent implements OnInit {

  constructor( private dialog: MatDialog,
               private notificationToastService: NotificationToastService,
               private billingOrderControlService: BillingOrderControlService) { }

  ngOnInit() {
 
  }
}
